// Configuration file for Grassline Snake Game
// Update these values to match your server setup

// Get API base URL - runtime detection to avoid mixed content errors
// This function is called each time to ensure it always checks the current protocol
export function getApiBaseUrl() {
    if (typeof window !== 'undefined') {
        // Always use same origin when served over HTTPS to avoid mixed content
        if (window.location.protocol === 'https:') {
            return window.location.origin;
        }
        // For HTTP, use same origin in production, or dev URL in development
        if (process.env.NODE_ENV === 'production') {
            return window.location.origin;
        }
    }
    // Fallback for development (HTTP only)
    return 'http://81.0.246.123:5000';
}

export const CONFIG = {
    // Server Configuration - use getter function for runtime detection
    // Note: API_BASE_URL is now accessed via getApiBaseUrl() function
    get API_BASE_URL() {
        return getApiBaseUrl();
    },
    
    // API Endpoints
    ENDPOINTS: {
        HEALTH: '/api/health',
        LEADERBOARD: '/api/leaderboard',
        SCORES: '/api/scores',
        HIGH_SCORE: '/api/high-score',
        STATS: '/api/stats'
    },
    
    // Request Configuration
    REQUEST_TIMEOUT: 10000, // 10 seconds
    RETRY_ATTEMPTS: 3,
    
    // Cache Configuration
    CACHE_DURATION: 3600000, // 1 hour in milliseconds
    
    // Rate Limiting (client-side)
    MAX_REQUESTS_PER_MINUTE: 60,
    
    // Game Configuration
    LEADERBOARD_LIMIT: 50,
    LOCAL_STORAGE_BACKUP: true,
    
    // Debug Configuration
    DEBUG_MODE: process.env.NODE_ENV === 'development',
    LOG_API_CALLS: true
};

// Helper function to get full API URL
export function getApiUrl(endpoint) {
    // Call getApiBaseUrl() directly to ensure runtime detection
    return getApiBaseUrl() + endpoint;
}

// Helper function to check if we're in production
export function isProduction() {
    return process.env.NODE_ENV === 'production';
}

// Helper function to get server status
export function getServerStatus() {
    return {
        baseUrl: CONFIG.API_BASE_URL,
        isProduction: isProduction(),
        endpoints: CONFIG.ENDPOINTS
    };
}
